/**
 * AuthLayout — 로그인/인증 관련 페이지 외곽 레이아웃.
 *
 * 【역할】
 * - 로그인/비밀번호 변경 등 비인증 페이지의 공통 컨테이너.
 * - 브랜드 그라디언트 배경(colorPrimary → colorPrimaryBorderHover) + 센터 정렬.
 *
 * 【주요 기능】
 * - ConfigProvider 로 antd 테마 주입 (useTheme.themeConfig + componentDefaults).
 * - `<Outlet />` 에 LoginPage / PasswordChangePage 등 자식 라우트 렌더.
 *
 * 【사용 위치】
 * - router/index.tsx path='/login' element 로 지정.
 *
 * 【포팅 원본】 react-spring-fw AuthLayout.vue.
 *
 * 【의존성】 react-router-dom Outlet, antd ConfigProvider/Flex/antdTheme, useTheme.
 */
import { Outlet } from 'react-router-dom'
import { ConfigProvider, Flex, theme as antdTheme } from 'antd'
import { useTheme } from '@/framework/useTheme'

/**
 * AuthLayout — 컴포넌트/함수 (자동 생성된 JSDoc 스텁).
 * @returns 렌더 결과 또는 반환값
 */
export default function AuthLayout() {
  const { themeConfig, componentDefaults } = useTheme()
  return (
    <ConfigProvider theme={themeConfig} {...componentDefaults}>
      <AuthLayoutInner />
    </ConfigProvider>
  )
}

/** ConfigProvider 내부에서 useToken 사용을 위한 분리 컴포넌트 (token 은 Provider 자식에서만 유효). */
function AuthLayoutInner() {
  const { token } = antdTheme.useToken()
  return (
    <Flex
      align="center"
      justify="center"
      style={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${token.colorPrimary} 0%, ${token.colorPrimaryBorderHover} 100%)`
      }}
    >
      <Outlet />
    </Flex>
  )
}
